import { useEffect, useState } from "react";
import { CallPopUpAgentActions } from "../../../store/slices/voice_call_slice/call_popup_agent";
import { WtButton } from "../../../shared/widges/Button/button";
import _ from "lodash";
import styles from "./incomingMeet.module.scss";
import { useDispatcher } from "../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import {videoCallService} from "../../../base/service/videoCallService";
import { askPermission, getVideoSessionById } from "../../../base/video_common";
import store from "../../../store/redux-store/root_store";
import { meetActionTypes } from "../../../base/action/action";
import callChatService from "../../../base/service/chatService";
import { ChatState } from "../../../base/models/model";
import { useSelector } from "react-redux";
import { ChatActions } from "../../../store/slices/chat_slice/chat_slice";
import { deviceState } from "../../../base/models/meetModal";

function IncomingVideoCallNotify() {
  const dispatch = useDispatcher();
  const navigate=useNavigate();
  const [over, setOver] = useState(false);
  const [[m, s], setTime] = useState<any>([0, 29]);
  const [acceptButton, setAcceptButton] = useState<boolean>(false);
  const {videoCallDetails,vm_acd_event}=store.getState().meetingReducer;
  const meetingDetails=store.getState().meetingReducer;
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  const acceptNotify =async () => {
    try{
    let mediaDeviceInfo:deviceState=store.getState().mediaDevice;
    let {vm_acd_event} : any=store.getState().meetingReducer;
    setAcceptButton(true);
    dispatch(CallPopUpAgentActions.videoAttendedCall({videoacceptCallRoom:false}));
    store.dispatch({
      type: meetActionTypes.AGENT_VIDEO,
      payload: {
       agentvideo:true,
       customerDetails:{}
      }
    });

    store.dispatch({
      type: meetActionTypes.SET_DURATION,
      payload: {
       startTime:new Date().getTime()
      }
    });
    let updatedInfo: any = videoCallDetails;
   if(meetingDetails.meetingDetails.agentDetails.hasOwnProperty("customerDetails")){ 
     let apiData:any= await getVideoSessionById(videoCallDetails.callId);
    let result:any=apiData?.data?.result?.length > 0 ? apiData?.data?.result[0] : [];
    updatedInfo = {
        ...updatedInfo, calledPersonDetails:meetingDetails.meetingDetails.agentDetails.customerDetails,customerNumber:meetingDetails.meetingDetails.agentDetails.customerNumber,queueName:meetingDetails.meetingDetails.agentDetails.queueName,
        sessionId:meetingDetails.meetingDetails.uuid
    ,channelType:"Video",videoHistoryId:result?.VideoHistoryId ? result?.VideoHistoryId : ""
    };
    store.dispatch({
      type: meetActionTypes.VIDEO_CALL_DETAILS,
      payload: {
       videoCallDetails:updatedInfo
      }
    });
    const ringer: any = document.getElementById("ringer");
    ringer.pause();
  
    await dispatch(ChatActions.chatSessionList(updatedInfo));
    await dispatch(ChatActions.currentChatSession(updatedInfo));
    navigate('/chatscreenagent');
  }
      new videoCallService(dispatch).createConnection(meetingDetails.meetingDetails.uuid,vm_acd_event === 4 ? true : false);
      console.log("before ask permission",mediaDeviceInfo);
      askPermission(dispatch)
      setAcceptButton(false);
}
catch(e:any){
console.log("accept notify",e);
}

  };
  const declineNotify = () => {
    try{
    const meetingDetails=store.getState().meetingReducer;
    let {vm_acd_event} : any=store.getState().meetingReducer;
    setOver(true);
    const ringer: any = document.getElementById("ringer");
    ringer.pause();
    dispatch(CallPopUpAgentActions.videoAttendedCall({videoacceptCallRoom:false}));
    store.dispatch({
        type: meetActionTypes.AGENT_VIDEO,
        payload: {
         agentvideo:false,
         customerDetails:{},
         videoPopUp:false
        }
      });

      if(vm_acd_event === 1){const declineData = {
        session_id:meetingDetails?.meetingDetails?.uuid,
        meet_event: 3
        
      };      callChatService.videoMeetDecline(declineData);}
      else{
        {const declineData = {
          session_id:meetingDetails?.meetingDetails?.uuid,
          meet_event: 6
          
        };      callChatService.videoMeetDecline(declineData);}
      }
    }
    catch(e:any){
     console.log("decline notify error>>",e);
    }
  };


  useEffect(() => {
    const timerID = setInterval(() => tick(), 1000);
    const ringer: any = document.getElementById("ringer");
    if (over) {
      ringer.pause();
      clearInterval(timerID);

      dispatch(CallPopUpAgentActions.NotAttendedCall());
    }
    return () => {
      clearInterval(timerID);
    };
  });

  const tick = () => {
    if (m === 0 && s === 0) {
      setOver(true);
    } else {
      setTime([m, s - 1]);
    }
  };

  return (
    <>
      <div className={`${styles.callcontainartopsec}`}>
        <div className={styles.incomingTop}>
          <span>
          <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3775_61181)">
<g filter="url(#filter0_d_3775_61181)">
<path d="M37.6569 20.9324C35.7221 19.0008 32.904 18.7226 30.2523 18.657C29.0348 18.6243 27.9963 18.6079 26.9575 18.6079C25.9187 18.6079 24.8802 18.6243 23.6627 18.657C21.0277 18.7226 18.1927 19.0008 16.2583 20.9324C14.2571 22.9462 14.2738 26.2204 14.2236 28.8072V35.2084C14.2738 37.7953 14.2571 41.0694 16.2583 43.0668C18.1927 44.9983 21.0112 45.2769 23.6627 45.3421C24.8802 45.3748 25.9187 45.3914 26.9575 45.3914C27.9963 45.3914 29.0348 45.3748 30.2523 45.3421C32.8871 45.2769 35.7221 44.9983 37.6569 43.0668C39.6578 41.0694 39.6414 37.7953 39.6912 35.2084C39.7081 34.1443 39.7246 33.0637 39.7081 31.9997C39.7081 30.9357 39.7081 29.8716 39.6912 28.791C39.6412 26.2042 39.6578 22.9299 37.6569 20.9324Z" fill="white"/>
<path d="M47.7173 23.3603C47.3749 23.3603 47.0238 23.457 46.6924 23.6692L40.6805 27.5208V36.4785L46.6924 40.3297C47.0238 40.542 47.3753 40.639 47.7177 40.639C48.7916 40.639 49.7769 39.686 49.7769 38.3539V25.6456C49.7769 24.3139 48.7913 23.3603 47.7173 23.3603Z" fill="white"/>
</g>
</g>
<defs>
<filter id="filter0_d_3775_61181" x="8.22363" y="14.6079" width="47.5537" height="38.7837" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="3"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3775_61181"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3775_61181" result="shape"/>
</filter>
<clipPath id="clip0_3775_61181">
<rect width="42.6667" height="42.6667" fill="white" transform="translate(10.667 10.6665)"/>
</clipPath>
</defs>
</svg>

          </span>
          <span>Incoming Call...</span>
        </div>
        <div className={styles.callwhisperinnercon}>
          <div className={styles.succesconsec}>
            {/* <div className={styles.userconsec}>
              <span>
              {`${meetingDetails?.meetingDetails?.agentDetails?.customerDetails?.firstName && meetingDetails?.meetingDetails?.agentDetails?.customerDetails?.firstName.trim() !== ""}` ? `${meetingDetails?.meetingDetails?.agentDetails?.customerDetails?.firstName}` : "New Customer"}
              </span>
              <label className={styles.phnenumber}>{meetingDetails?.meetingDetails?.agentDetails?.customerNumber}</label>
            </div> */}
            {meetingDetails?.meetingDetails?.agentDetails?.customerDetails?.firstName?.length > 20 ?
              <div className={`${styles.userconsec} ${styles.widthfull}`}>
                <div className={"marqueeWrapper"}>
                  <span className="marqueeEffect">{`${meetingDetails?.meetingDetails?.agentDetails?.customerDetails?.firstName && meetingDetails?.meetingDetails?.agentDetails?.customerDetails?.firstName.trim() !== ""}` ? `${meetingDetails?.meetingDetails?.agentDetails?.customerDetails?.firstName}` : "New Customer"}</span>

                  <span className="marqueeEffect">{`${meetingDetails?.meetingDetails?.agentDetails?.customerDetails?.firstName && meetingDetails?.meetingDetails?.agentDetails?.customerDetails?.firstName.trim() !== ""}` ? `${meetingDetails?.meetingDetails?.agentDetails?.customerDetails?.firstName}` : "New Customer"}</span>
                </div>
                <label className={styles.phnenumber}>{meetingDetails?.meetingDetails?.agentDetails?.customerNumber}</label>
              </div>
              :
              <div className={styles.userconsec}>
                <span>{`${meetingDetails?.meetingDetails?.agentDetails?.customerDetails?.firstName && meetingDetails?.meetingDetails?.agentDetails?.customerDetails?.firstName.trim() !== ""}` ? `${meetingDetails?.meetingDetails?.agentDetails?.customerDetails?.firstName}` : "New Customer"}</span>

                <label className={styles.phnenumber}>{meetingDetails?.meetingDetails?.agentDetails?.customerNumber}</label>
              </div>
            }
            <div className={styles.supportconsec}>
              <span className={styles.curntsuprt}>{meetingDetails?.meetingDetails?.agentDetails?.queueName}</span>
              <label className={styles.anstxt}>
                Answer in{" "}
                <span className={styles.timecount}>
                  <p>{`${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`}</p>
                </span>
              </label>
            </div>
            <div className={styles.acceptbtnconsec}>
              <WtButton className={`buttonGreen ${styles.declinebtn}`} onClick={declineNotify} onTouchStart={declineNotify} name="Decline" />
              <WtButton className={acceptButton ? `buttonGreen ${styles.acceptbtn} disaled` : `buttonGreen ${styles.acceptbtn}`} onClick={acceptNotify} onTouchStart={acceptNotify} name="Accept" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default IncomingVideoCallNotify;
